import { Injectable } from '@angular/core';
import { LinkParams } from '../models/link-params.model';
import { safeSessionStorage } from '../utils/safe-storage';

@Injectable({
  providedIn: 'root'
})
export class LinkParamsService {
  constructor() {
    this.loadData();
  }
  private params: LinkParams;

  get linkParams() {
    return this.params;
  }

  get customer(): string {
    return !!this.params.surname ? [this.params.name, this.params.surname].join(' ').trim() : null;
  }

  private readonly LOCAL_STORAGE_KEY = 'link-params';

  storeLinkParams(data: LinkParams) {
    safeSessionStorage.setItem(this.LOCAL_STORAGE_KEY, JSON.stringify(data));
    this.params = data;
  }

  private loadData() {
    const dataStr = safeSessionStorage.getItem(this.LOCAL_STORAGE_KEY);
    this.params = !!dataStr ? JSON.parse(dataStr) : {};
  }
}
